import styled from "styled-components";
import { BaseButton, colors, types } from "../../../libs";
import { Card, Modal, Spinner } from "react-bootstrap";


export const ModalHeader = styled(Modal.Header)`
  background: ${colors.background.black};
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
    color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const LoadingSpinner = styled(Spinner)`
    margin-right: 10px;
`;

export const FixedWidthButton = styled(BaseButton)`
    width: 200px; 
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px; 
`;

export const ModalBody = styled.div`
  flex: 1;
  padding: 20px;
  max-height: calc(100vh - 60px);
`;

export const BigTitle = styled.h2`
  ${types.headers.secondary};
  line-height: 1;
  background: ${colors.text.textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 40px;
  margin-bottom: 90px; 
`;

export const Title = styled.h2`
 ${types.headers.item};
    color: ${colors.text.mediumWhite};
    margin-bottom: 10px;
`;

export const Subtitle = styled.p`
 ${types.body.subtitle};
  color:  ${colors.text.lightGray};
  margin-bottom: 30px;
`;

export const Label = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin: 18px 0 5px;
  color: #84818A;
  margin-bottom: 10px; 
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 5px;
  outline: none;
   margin-bottom: 20px; 
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 5px;
  outline: none;
  margin-bottom: 20px; 
`;

export const Footer = styled.div`
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: start;
    gap: 0px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top:20px;
`;

export const AttachmentsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
`;


export const selectStyles = {
  menu: (baseStyles) => ({
    ...baseStyles,
    background: colors.background.formField,
    borderColor: "transparent",
    color: colors.text.white,
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    background: state.isFocused ? "#ccc" : colors.background.formField,
    color: state.isSelected ? colors.text.white : state.isFocused ? colors.background.formField : colors.text.white,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white,
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: "50px",
    background: colors.background.formField,
    color: colors.text.white,
    border: state.isFocused ? "1px solid transparent" : "1px solid transparent",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.gray,
    fontSize: types.body.label
  }),
};


export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TicketInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PriorityDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
`;

export const TicketId = styled.span`
 ${types.headers.small};
  color: ${colors.text.mediumWhite};
`;

export const PostedAt = styled.p`
 ${types.body.normal};
  color: ${colors.text.lightGray};
  margin-bottom: 20px;
  padding-left: 21px;
`;

export const TicketDescription = styled.p`
 ${types.body.label};
  color: ${colors.text.white};
  border-radius: 5px;
  margin-bottom: 20px;
`;


export const AttachmentImage = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 5px;
  object-fit: cover;
`;

export const PriorityTag = styled.span`
 ${types.body.small};
  background-color:  ${colors.background.lightRed};
  color:  ${colors.text.error};;
  padding: 4px 8px;
  border-radius: 4px;
`;
export const TicketWrapper = styled.div`
    width: 75%;
    margin-right: auto;
    padding: 20px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; 
`;

export const Wrapper = styled(Card)`
  background:  ${colors.background.black};
  padding: 20px;
  margin: 20px 0px;
  border-radius: 8px;
  border: 1px solid ${colors.background.lightWhite};
  width: 100%;
`;

export const TicketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CloseTicketButton = styled.button<{ status: string }>`
 ${types.headers.small};
  width: 157px;
  height: 44px;
  background-color: ${({ status }) => (status === "6" ? colors.background.lightGreen : colors.background.red)};
  color:  ${colors.text.white};
  border: none;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background-color: ${({ status }) => (status === "6" ? "#7BB731" : "#CC0000")};
  }
`;

export const RepliesWrapper = styled.div`
    margin-top: 20px;
    padding: 10px;
`;

export const RepliesTitle = styled.h3`
   ${types.headers.item};
    margin-bottom: 15px;
`;

export const ReplyItem = styled.div`
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 5px;
`;

export const ReplyHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const ReplyTitle = styled.h4`
${types.headers.small};
`;

export const ReplyDate = styled.p`
    font-size: 12px;
    color:  ${colors.text.lightGray};
    margin-bottom: 3px;
`;
export const ReplySubtitle = styled.p`
   ${types.body.normal};
   color:  ${colors.text.lightGray};
    margin-top: 5px;
`;

export const ReplyImageWrapper = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 10px;
`;

export const ReplyImage = styled.img`
    width: 96px;
    height: 68px;
    object-fit: cover;
    background-color:'red';
`;

export const AttachmentContainer = styled.div`
    position: relative;
    display: inline-block;
    margin: 10px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    width: 100px;
    height: 100px;
`;

export const RemoveIcon = styled.button`
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover {
        background: ${colors.text.error};
    }
`;